import ErrorPage from "../views/page/error/ErrorPage";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import SettingManager from "../views/page/setting/manager/Index";
import SubAdmin from "../views/page/setting/manager/SubAdmin";
import SubAdminWrite from "../views/page/setting/manager/SubAdminWrite";
import { isMasterAdmin } from "../utils/AdminAuth.utils";
import PopupList from "../views/page/setting/design/PopupList";
import PopupWrite from "../views/page/setting/design/PopupWrite";
import AccountList from "../views/page/setting/account/AccountList";
import Auto from "../views/page/setting/push/Auto";
import Manual from "../views/page/setting/push/Manual";
import PushList from "../views/page/setting/push/PushList";
import PushWrite from "../views/page/setting/push/PushWrite";
import CouponIssue from "../views/page/setting/coupon/CouponIssue";
import CouponList from "../views/page/setting/coupon/CouponList";
import SearchKeyword from "../views/page/setting/search/SearchKeyword";
import Privacy from "../views/page/setting/policy/Privacy";
import Terms from "../views/page/setting/policy/Terms";

const MasterRoute = ({ children }) => {
  if (!isMasterAdmin()) return <Navigate to="/Setting/Manager/My" replace />;
  return children;
};

function RouterSetting() {
  return (
    <>
      <Routes>
        <Route exact path="/Manager" element={<Navigate to={isMasterAdmin() ? "/Setting/Manager/Admin" : "/Setting/Manager/My"} replace />} />
        <Route exact path="/Manager/Admin" element={<MasterRoute><SettingManager pageTitle="관리자 계정 관리" /></MasterRoute>} />
        <Route exact path="/Manager/My" element={<SettingManager pageTitle="내 정보 변경" />} />
        <Route exact path="/Manager/SubAdmin" element={<MasterRoute><SubAdmin /></MasterRoute>} />
        <Route exact path="/Manager/SubAdmin/Write" element={<MasterRoute><SubAdminWrite /></MasterRoute>} />
        <Route exact path="/Manager/SubAdmin/Write/:admin_seq" element={<MasterRoute><SubAdminWrite /></MasterRoute>} />
        <Route exact path="/Design/PopupList" element={<PopupList />} />
        <Route exact path="/Design/PopupList/Write" element={<PopupWrite />} />
        <Route exact path="/Account/AccountList" element={<AccountList />} />

        <Route exact path="/Push/Auto" element={<Auto />} />
        <Route exact path="/Push/Auto/PushWrite" element={<PushWrite />} />
        <Route exact path="/Push/Manual" element={<Manual />} />
        <Route exact path="/Push/PushList" element={<PushList />} />
        <Route exact path="/Push/PushList/PushWrite" element={<PushWrite />} />

        <Route exact path="/Coupon/CouponIssue" element={<CouponIssue />} />
        <Route exact path="/Coupon/CouponList" element={<CouponList />} />
        <Route exact path="/SearchKeyword" element={<SearchKeyword />} />
        <Route exact path="/Policy/Terms" element={<Terms />} />
        <Route exact path="/Policy/Privacy" element={<Privacy />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default RouterSetting;
